import { render, staticRenderFns } from "./UpdateButton.vue?vue&type=template&id=4ed7e684"
import script from "./UpdateButton.vue?vue&type=script&lang=js"
export * from "./UpdateButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports